import axios from "axios";
import MockAdapter from "axios-mock-adapter";


const mock=new MockAdapter(axios);

export default mock;
